module.exports = __webpack_public_path__ + "static/media/bollettini.79b1068a.svg";